function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import { AelfIcon } from "../../icon/AelfIcon";
var AelfSVGComponent = function AelfSVGComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m21.774 4.762-5.688 1.785 6.27.004-.582-1.79Zm-.323-2.52a2.05 2.05 0 0 1 2.563 1.324l.97 2.986H27.5a2.25 2.25 0 0 1 2.25 2.25v18a2.25 2.25 0 0 1-2.25 2.25h-23a2.25 2.25 0 0 1-2.25-2.25v-18a2.25 2.25 0 0 1 2.25-2.25h3.223l13.728-4.31ZM4.75 9.053v17.5h22.5v-5h-3.125c-2.082 0-3.875-1.622-3.875-3.75s1.793-3.75 3.875-3.75h3.125v-5h-1.454v.001L4.75 9.052Zm22.5 7.5h-3.125c-.818 0-1.375.616-1.375 1.25 0 .633.557 1.25 1.375 1.25h3.125v-2.5Z"
  }));
};
var componentName = 'WalletOutlined';
export var WalletOutlined = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(AelfIcon, _extends({
    component: AelfSVGComponent,
    ref: ref
  }, props));
});
WalletOutlined.displayName = componentName;